<template>
    
    <span>
      <template v-if="word.type == 'word'">
        <b-link v-if="word.word !== hiligthed" v-html="hiligthed" class="word" v-bind:class="[word.bold ? 'boldClass' : '', word.italic ? 'italicClass' : '', word.underline ? 'underlineClass' : '']" :id="wordId" @mouseover="mouseOver" @mouseleave="mouseLeave" @click="showTooltip"></b-link>
        <b-link v-else class="word" v-bind:class="[word.bold ? 'boldClass' : '', word.italic ? 'italicClass' : '', word.underline ? 'underlineClass' : '']" :id="wordId" @mouseover="mouseOver" @mouseleave="mouseLeave" @click="showTooltip">{{word.word}}</b-link>

        <b-tooltip :target="wordId" :show.sync="showtt" triggers="manual" placement="bottom" :fallback-placement="flippos" custom-class="customTooltip">
          <div v-if="!loaded">
              <LoadingSpinner/>
          </div>
          <div v-else>
            <div v-if="curWordMorph.length == 0">
              Морфология не найдена
            </div>
            <div v-else>
              <div :class="{'udm-font': isEaf}">
                <b>{{ word.word }}</b>
                <!-- <b v-if="word.originalWord"> ({{ word.originalWord }})</b> -->
              </div>
              <div v-for="morph in curWordMorph" :key="morph.id" class="morph">
                <div v-if="morph.lex">lex: {{ morph.lex }}</div>
                <div v-if="morph.gr">gr: {{ morph.gr }}</div>
                <div v-if="morph.parts">parts: {{ morph.parts }}</div>
                <div v-if="morph.gloss">gloss: {{ morph.gloss }}</div>
                <div v-if="morph.trans_ru">trans_ru: {{ morph.trans_ru }}</div>
              </div>
            </div>
          </div>
        </b-tooltip>

      </template>
      <br v-else-if="word.type == 'linebreak'"/>
      <template v-else>{{word.word}}</template>
      <span v-if="word.hasSpace" style="width:4px;display:inline-block;">&nbsp;</span>

    </span>
</template>

<script>
import { searchService, morphService } from '@/_services'
import LoadingSpinner from '@/components/utils/LoadingSpinner'

export default {
  name: "chunkword",
  components: {
    LoadingSpinner
  },
  props: {
      chunk: {
          type: Object,
          default: null
      },
      index: {
        type: Number,
        default: 0
      },
      word: {
          type: Object,
          default: null
      },
      filter: {
          type: Object,
          default: null
      }
  },
  mounted() {
    if (this.word.type == "word") this.hiligthed = this.makeHiligth();
  },
  computed: {
    wordId(){return 'chunk_'+this.chunk.id+'_index_'+this.index+'_word_'+this.word.id},
    flippos() {return ['top', 'bottom', 'right', 'left', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'left-top', 'left-bottom', 'right-top', 'right-bottom']},
    isEaf(){
      return this.chunk.publication.file.toLowerCase().endsWith('.eaf')
    }
  },
  methods: {
    makeHiligth(){
      let text = this.word.word;
      if (this.word.hilighted || this.word.originalWord.some(el => el.hilighted)) {
        return text = '<b>'+text+'</b>';
      }

      if (this.filter.fullcompare) {
        if (text == this.filter.word) {
          return text = '<b>'+text+'</b>';
        }
      } else {

        if (this.filter.searchMode == 1){
          if (this.filter.text.split(' ').includes(this.word.word) || this.filter.text.split(' ').includes(this.word.originalWord)) this.word.hilighted = true;
        } else {
          if (this.filter.word.split(' ').includes(this.word.word) || this.filter.word.split(' ').includes(this.word.originalWord)) this.word.hilighted = true;
        }
        
        if (this.word.hilighted || this.word.originalWord.some(el => el.hilighted)) {
          text = '<b>'+text+'</b>';
        } else {
          let tomatch = this.filter.word;
          if (this.filter.searchMode == 1) tomatch = this.filter.text;
          let all = true;
          if (tomatch=='' || text=='') return text;
          if (this.filter.fullcompare && text === tomatch) text = '<b>'+text+'</b>';
          else {
            var f = text.match(new RegExp(tomatch,'ig'));
            if (this.filter.searchMode == 1) f = text.match(new RegExp(tomatch.replace(new RegExp(' ','ig'),'|'),'ig'));
            var fnd = '';
            if (f===null) return text;
            if (all) {
                for (var i=0;i<=f.length-1;i++){
                    text = text.replace(f[i],'{'+i+'}');
                }
                for (var i=0;i<=f.length-1;i++){
                    text = text.replace('{'+i+'}','<b>'+f[i]+'</b>');
                }
            } else text = text.replace(f[0],'<b>'+f[0]+'</b>');
          }
        }
      }
      return text;
    },
    loadMorpho(){
      this.loaded = false;
      let i = 0;
      let str = this.word.word.trim().toLowerCase();
      let reg = new RegExp('[!@#$%^&*()_+|,\. «»:;]','ig');

      searchService.getana(this.word)
      .then(data => {
        this.curWordMorph = data;
        this.loaded = true;
      })
    },
    showTooltip(){
      this.showtt = true;
    },
    mouseOver(){
      this.mousein = true;
      let _self = this;
      setTimeout(function(){
        if (_self.mousein) _self.showtt = true;
      },1000)
      if (this.curWordMorph == null) {
        this.loadMorpho();
      }
    },
    mouseLeave (){
      this.mousein = false;
      this.showtt = false;
    }
  },
  data(){
    return{
      hiligthed:this.word.word,
      curWordMorph:null,
      loaded:false,
      mousein:false,
      showtt:false
    }
  }
}
</script>

<style @scoped>
  .word {color: #23282c;}
  .word:hover {color:red;border-bottom: 1px dotted;text-decoration: none;}
  .word b {color:red;}
  div.morph {text-align:left;border-bottom:1px solid #fff;margin-bottom: 5px;padding-bottom: 5px;}
  div.morph:last-child {border-bottom:0 none;}
  div.morph > div {border-bottom:1px dotted #fff;font-size: 12px;}
  div.morph > div:last-child {border-bottom:0 none;}
  div.morph > div > b {font-size: 14px;}
  .customTooltip {width:250px !important;}
  .customTooltip .tooltip-inner {max-width: 250px !important;}

  .boldClass {font-weight: bold;}
  .italicClass {font-style: italic;}
  .underlineClass {text-decoration: underline;}
</style>